import React from 'react';
import {
    Tooltip,
    message
} from "antd";
import { useDispatch } from 'react-redux';
// Icon

import VideocamIcon from '@mui/icons-material/Videocam';
import { TIME } from '../../../services/util';
// Micro

import { remove_enabled_vehicle_pop_up } from '../../../services/redux/actions/mapControl';
import { set_selected_live_camera_by_vid_request } from '../../../services/redux/actions/liveCamera';

/**
 * Initially yes
 * Once data received, then would switch to either no/yes
 * @param {} vehicle 
 */
const LiveCameraDefiner = (deviceMDVR, vid) => {

    const dispatch = useDispatch();

    let color
    let msg

    if(!deviceMDVR) {
        color = 'black'
        msg = 'No MDVR Detected'
    }
    else if(deviceMDVR?.IsOnline) {
        color = 'green'
        msg = 'MDVR is currently online.'
    }
    else if(!deviceMDVR?.IsOnline) {
        const lastOffline = TIME.getUTCToMalay(deviceMDVR.OffLineTime)

        color = 'red'
        msg = `Last Online at ${lastOffline || '-'}`
    }

    const clickIconHDLR = () => {
        dispatch(remove_enabled_vehicle_pop_up(vid));
        // console.log(deviceMDVR, vid)

        if(!deviceMDVR?.IsOnline) {
            message.warning('We are unable to retrieve playback. MDVR is currently offline.')
        }
        else if(deviceMDVR.DeviceId && deviceMDVR?.IsOnline) {
            dispatch(set_selected_live_camera_by_vid_request(vid, deviceMDVR.DeviceId, true))
        }
        else {
            message.error('Playback unsuccessful. Vehicle is not assigned with MDVR')
        }
    }

        return (
            <Tooltip 
                placement="top" 
                title={msg}
            >
                    <VideocamIcon sx={{ fontSize: 20, color: color }} onClick={clickIconHDLR}/>
            </Tooltip>
        )
    // else {
        
    //     if( vehicle && Object.prototype.hasOwnProperty.call(vehicle, 'pwr_int_lvl')) {

    //         const {
    //             pwr_int_lvl = 0
    //         } =  vehicle

    //         return (
    //             <WarningIcon batteryLVL = {pwr_int_lvl} />
    //         )

    //     } else {
    //         return (
    //             <Tooltip 
    //                 placement="top" 
    //                 // title={UndetectedDeviceBatteryLevelTitle}
    //             >
    //                 <WarningIcon sx={{ fontSize: 20, color: "orange" }}/>
    //             </Tooltip>
    //         )
    //     }
    // }
}

const LiveCameraIcon = ({deviceMDVR, vid}) => {
    return <>
        {
            LiveCameraDefiner(deviceMDVR, vid)
        }
    </>
}

export default LiveCameraIcon